import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { errorCatch } from './errorCatcher.reducer';

export interface PaymentMethod {
  name: string;
  id: string;
  type: string;
  cardType: string;
}

export type ZuoraIframeParams = {
  key: string;
  signature: string;
  tenantId: string;
  token: string;
  field_accountId: string;
  locale: string;
  style: string;
  submitEnabled: string;
  id: string;
  url: string;
};

export type ZuoraIFrameSignatureTypes = {
  ACH?: ZuoraIframeParams;
  CreditCard?: ZuoraIframeParams;
};

export type PaymentState = {
  paymentMethod: PaymentMethod;
  zuoraIframeSignature: ZuoraIFrameSignatureTypes;
  status: string;
  paymentMethodRefId: string;
};

const initialPaymentMethod = {
  name: '',
  id: '',
  type: '',
  cardType: ''
};

export const initialState = {
  paymentMethod: initialPaymentMethod,
  paymentMethodRefId: '',
  zuoraIframeSignature: {},
  status: ''
} as PaymentState;

export const getZuoraIframeSignature = createAsyncThunk(
  'paymentReducer/getZuoraIframeSignature',
  async (type: string, { dispatch }) => {
    try {
      const { data } = await Axios.get('/api/v1/billing/PaymentMethod/page', { params: { type } });
      return { type, data };
    } catch (error) {
      dispatch(errorCatch({ place: 'paymentReducer/getZuoraIframeSignature.rejected', data: error }));
      return Promise.reject(error);
    }
  }
);

export const getPaymentMethodDetails = createAsyncThunk(
  'paymentReducer/getPaymentMethodDetails',
  async (id: string, { dispatch }) => {
    try {
      const { data } = await Axios.get('/api/v1/billing/PaymentMethod', { params: { id } });
      return data;
    } catch (error) {
      dispatch(errorCatch({ place: 'paymentReducer/getPaymentMethodDetails.rejected', data: error }));
      return Promise.reject(error);
    }
  }
);

const slice = createSlice({
  name: 'paymentReducer',
  initialState,
  reducers: {
    clearPaymentMethod: state => {
      state.paymentMethod = initialPaymentMethod;
    }
  },
  extraReducers: {
    [getZuoraIframeSignature.pending.toString()]: state => {
      state.status = 'loading';
    },
    [getZuoraIframeSignature.fulfilled.toString()]: (state, action) => {
      state.zuoraIframeSignature[action.payload.type] = { ...action.payload.data };
      state.status = 'success';
    },
    [getZuoraIframeSignature.rejected.toString()]: state => {
      state.status = 'rejected';
    },

    [getPaymentMethodDetails.pending.toString()]: state => {
      state.status = 'loading';
    },
    [getPaymentMethodDetails.fulfilled.toString()]: (state, action) => {
      state.paymentMethod = action.payload;
      state.status = 'success';
    },
    [getPaymentMethodDetails.rejected.toString()]: state => {
      state.status = 'rejected';
    }
  }
});

export const { clearPaymentMethod } = slice.actions;

export default slice.reducer;
